module.exports = __webpack_public_path__ + "img/onpremises.bfca060f.svg";